import { z } from 'zod'

export const columns = [
  { id: 'username', label: 'User ID', width: '160px' },
  { id: 'name', label: 'User name', width: '150px' },
  { id: 'emailId', label: 'Email ID', width: '200px' },
  {
    id: 'role',
    label: 'Business role',
    width: '170px',
    type: 'dropdown',
    options: [
      { label: 'ADMIN', value: 'ADMIN' },
      { label: 'PREPARER', value: 'PREPARER' },
      { label: 'API USER', value: 'API_USER' },

    ],
    render: value => (Array.isArray(value) ? value.join(', ') : value || 'N/A'),
  },
  {
    id: 'isLocked',
    label: 'Is locked',
    width: '100px',
    type: 'dropdown',
    options: [
      { id: 1, label: 'Yes', value: true },
      { id: 2, label: 'No', value: false },
    ],
    // render: value => (value ? 'Yes' : 'No'),
  },
  {
    id: 'isActive',
    label: 'Active',
    width: '100px',
    type: 'dropdown',
    options: [
      { id: 1, label: 'Yes', value: true },
      { id: 2, label: 'No', value: false },
    ],
    // render: value => (value ? 'Yes' : 'No'),
  },
  {
    id: 'isSSOUser',
    label: 'SSO user',
    width: '100px',
    type: 'dropdown',
    options: [
      { id: 1, label: 'Yes', value: true },
      { id: 2, label: 'No', value: false },
    ],
    // render: value => (value ? 'Yes' : 'No'),
  },
  {
    id: 'createdBy',
    label: 'Created by',
    width: '150px',
    minWidth: '120px',

  },
  {
    id: 'createdDate',
    label: 'Created date',
    width: '180px',
  },
  {
    id: 'lastModifiedBy',
    label: 'Updated by',
    width: '150px',
    minWidth: '120px',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
    width: '180px',
  },
]

// Validation for yyyymmdd date format
const ddMMyyyyListZod = z
  .string()
  .regex(
    /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}(\s*,\s*(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4})*)?$/,
    'Invalid Input. Example: 29/08/2025, 01/09/2025'
  )
// Search fields constant (add Load ID and all columns)
export const searchFields = [
  ...columns.map(col => {
    if (
      col.id === 'createdDate' ||
      col.id === 'lastModifiedDate'
    ) {
      return {
        ...col,
        type: 'text',
        placeholder: `Example: 25/08/2025 (dd/mm/yyyy)`,
        zod: ddMMyyyyListZod,
      }
    }
    return {
      ...col,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    }
  }),
]
